<!-- src/views/works/BrandingView.vue -->
<template>
  <div class="page-wrapper">
    <div class="page-card">
      <div class="category-header">
        <span class="category-icon">🎯</span>
        <h1>品牌设计作品</h1>
      </div>
      <p class="category-desc">LOGO设计、VI视觉系统、品牌形象策划与包装设计。</p>
      
      <div class="works-grid">
        <div class="work-card" v-for="work in works" :key="work.id">
          <div class="work-icon">{{ work.emoji }}</div>
          <h3>{{ work.name }}</h3>
          <p>{{ work.desc }}</p>
        </div>
      </div>
      
      <div class="badge">品牌设计 · 共 {{ works.length }} 个作品</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandingView',
  data() {
    return {
      works: [
        { id: 1, name: '星云科技', desc: '科技品牌VI视觉系统', emoji: '⭐' },
        { id: 2, name: '绿野食品', desc: '食品品牌包装设计', emoji: '🌿' },
        { id: 3, name: '创艺教育', desc: '教育品牌形象升级', emoji: '🎨' },
        { id: 4, name: '云端金融', desc: '金融品牌LOGO设计', emoji: '☁️' }
      ]
    };
  }
};
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  background: #f8fafc;
  padding: 2rem;
}

.page-card {
  background: white;
  border-radius: 1.5rem;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  padding: 2rem;
  max-width: 1100px;
  margin: 0 auto;
}

.category-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.category-icon {
  font-size: 2.5rem;
}

h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #0c4a6e;
  margin: 0;
}

.category-desc {
  color: #64748b;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.works-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.5rem;
  margin: 1.5rem 0;
}

.work-card {
  background: #f8fafc;
  border-radius: 1rem;
  padding: 1.5rem;
  text-align: center;
  transition: all 0.3s;
  border: 1px solid #e2e8f0;
}

.work-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.work-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.work-card h3 {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  color: #1e293b;
}

.work-card p {
  font-size: 0.85rem;
  color: #64748b;
}

.badge {
  display: inline-block;
  background: #eef2ff;
  color: #1e40af;
  border-radius: 30px;
  padding: 0.3rem 1rem;
  font-size: 0.8rem;
  margin-top: 1rem;
}
</style>